<template>
    <div class="row align-items-center">
        <div class="col">
            <div class="row">
                <div class="col-6 border" v-for="(teethItem, index) in teeth" :key="index">
                    <div class="row">
                        <div class="col p-2 text-center" v-for="tooth in teethItem.items" :key="tooth">
                            <button
                                class="btn"
                                @click="view(tooth)"
                                :class="{'btn-outline-danger' : tooths[tooth], ' btn-white':!tooths[tooth]}"
                            >{{ tooth }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'



export default {
    props: ['type', 'value', 'tooths'],
    mixins: [modalMixins],
    data() {
        return {
            data: {},
            teeth: [
                { label: 'Top left', items: [18, 17, 16, 15, 14, 13, 12, 11] },
                { label: 'Top right', items: [21, 22, 23, 24, 25, 26, 27, 28] },
                { label: 'Bottom left', items: [48, 47, 46, 45, 44, 43, 42, 41] },
                { label: 'Bottom right', items: [31, 32, 33, 34, 35, 36, 37, 38] },
            ],
        }
    },

    methods: {

        view(tooth) {

            let toothItem = {
                tooth,
                _id: 'temp'
            };
            const { Treatment } = this.$FeathersVuex;
            new Treatment(toothItem);

            this.openModal({
                id: 'SingleToothModal',
                tooth: tooth,
            })
        },



    }

}
</script>

<style>

</style>
